module.exports = __webpack_public_path__ + "img/it-4.7ed71eb3.png";